var _style, _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.8 346.1",
    style: {
      enableBackground: "new 0 0 330.8 346.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DDDDDD;}\r\n\t.st1{fill:#878787;}\r\n\t.st2{fill:#D1D1D1;}\r\n\t.st3{fill:#C6C6C6;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#606060;}\r\n\t.st6{fill:#8C8C8C;}\r\n\t.st7{fill:#595959;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 142.4,
    cy: 30.5,
    r: 30.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.2,155.3v77.9c-19.1-10.9-45.1-18.8-74.7-22.3c-10.8-1.3-22-1.9-33.5-1.9c-9.8,0-19.3,0.5-28.6,1.4 c-29.8,2.9-56.3,10.4-76.1,20.9v-75.9c0-50.7,35.5-93.1,82.9-103.9c7.6-1.7,15.4-2.6,23.5-2.6c7.3,0,14.5,0.7,21.4,2.1 c7.7,1.6,15.1,4,22.1,7.1c9,4,17.4,9.3,24.9,15.6c2.4,2,4.7,4.1,7,6.3c12.2,12.2,21.5,27.4,26.6,44.3 C248.6,134.2,250.2,144.6,250.2,155.3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 250.2,
    cy: 99.3,
    r: 59.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.2,233.2c-19.1-10.9-45.1-18.8-74.7-22.3c-10.8-1.3-22-1.9-33.5-1.9c-9.8,0-19.3,0.5-28.6,1.4 c-29.8,2.9-56.3,10.4-76.1,20.9C14.1,243.4,0,259.7,0,277.5c0,37.9,63.5,68.6,141.9,68.6s141.9-30.7,141.9-68.6 C283.8,260.6,271.2,245.1,250.2,233.2z M142.8,327.8c-62.3,0-112.9-19.7-112.9-44c0-17.7,26.7-32.9,65.2-39.9 c14.5-2.6,30.6-4.1,47.6-4.1c18,0,35.1,1.7,50.2,4.6c37.1,7.2,62.6,22.2,62.6,39.4C255.6,308.1,205.1,327.8,142.8,327.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M255.6,283.8c0,24.3-50.5,44-112.9,44c-62.3,0-112.9-19.7-112.9-44c0-17.7,26.7-32.9,65.2-39.9 c14.5-2.6,30.6-4.1,47.6-4.1c18,0,35.1,1.7,50.2,4.6C230.1,251.5,255.6,266.5,255.6,283.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M255.6,283.8c0,24.3-50.5,44-112.9,44c-62.3,0-112.9-19.7-112.9-44c0-17.7,26.7-32.9,65.2-39.9 c14.5-2.6,30.6-4.1,47.6-4.1c18,0,35.1,1.7,50.2,4.6C230.1,251.5,255.6,266.5,255.6,283.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M193.2,248.7c0,27.1-22,49.2-49.2,49.2s-49.2-22-49.2-49.2c0-1.6,0.1-3.3,0.2-4.9c14.5-2.6,30.6-4.1,47.6-4.1 c18,0,35.1,1.7,50.2,4.6C193.1,245.8,193.2,247.2,193.2,248.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M279.5,125.5c-0.1,0.1-0.1,0.3-0.1,0.5c-0.9,2.7-4,3.5-6.1,1.7c-0.1-0.1-0.4-0.3-0.5-0.5 c-7.3-7.3-14.6-14.6-22-22c-0.1-0.1-0.3-0.4-0.4-0.6c-0.2,0.2-0.4,0.4-0.6,0.6c-7.4,7.4-14.8,14.8-22.1,22.1 c-1.2,1.2-2.7,1.6-4.2,1.1c-2.4-0.9-3.2-3.9-1.6-6c0.1-0.2,0.4-0.4,0.6-0.6c7.3-7.3,14.6-14.6,22-22c0.1-0.1,0.4-0.3,0.6-0.5 c-0.3-0.2-0.5-0.4-0.7-0.6c-7.4-7.4-14.7-14.7-22.1-22.1c-1.8-1.9-1.7-4.5,0.3-5.9c0.6-0.4,1.3-0.6,2-0.8c0.1,0,0.3,0,0.4,0 c1.4,0.1,2.4,1,3.3,1.9c7.2,7.2,14.3,14.3,21.5,21.5c0.1,0.1,0.3,0.3,0.6,0.6c0.1-0.2,0.2-0.4,0.4-0.6c7.2-7.2,14.3-14.3,21.4-21.5 c0.9-0.9,1.9-1.8,3.3-1.9c0.1,0,0.3,0,0.4,0c0.7,0.3,1.4,0.5,2.1,0.9c0.9,0.5,1.2,1.4,1.5,2.4c0,0.4,0,0.9,0,1.3 c-0.3,1.1-1,2-1.9,2.8c-7.2,7.2-14.4,14.4-21.6,21.6c-0.1,0.1-0.4,0.2-0.6,0.4c0.4,0.3,0.5,0.4,0.6,0.6c7.2,7.2,14.4,14.4,21.7,21.6 c0.8,0.8,1.5,1.6,1.8,2.8C279.5,124.7,279.5,125.1,279.5,125.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/no-notification.efb13de87ca921000a5e7fe5799cbbd8.svg";
export { ForwardRef as ReactComponent };